import { Text, Tooltip } from '@frameio/vapor';
import { IconInfo } from '@frameio/vapor-icons';
import TEXT from './generated/TEXT/VersionStackToggleRow';
import { SettingRowToggle } from './SettingRowToggle';
import styles from './VersionStackToggleRow.module.css';

TEXT.DEFINE({
  /** Label for the button to add the export to a version stack */
  addToVersionStack: 'Add to Version Stack',
  /** Tooltip text for the "Add to Version Stack" option */
  addToVersionStackTooltip:
    'Uploads to a Version Stack, grouping it with previous exports.',
});

export const VersionStackToggleRow = ({
  checked,
  onChange,
}: {
  /** Whether version stack mode is enabled. */
  checked: boolean;
  /** Called when the toggle state changes. */
  onChange: (checked: boolean) => void;
}) => {
  return (
    <SettingRowToggle
      checked={checked}
      data-testid="add-to-version-stack-toggle"
      label={
        <div className={styles.label}>
          <Text color="primary" style={{ textWrap: 'nowrap' }} variant="body">
            {TEXT.addToVersionStack}
          </Text>
          <Tooltip placement="top" title={TEXT.addToVersionStackTooltip}>
            <div className={styles.icon}>
              <IconInfo aria-label={TEXT.addToVersionStackTooltip} size={16} />
            </div>
          </Tooltip>
        </div>
      }
      onChange={onChange}
    />
  );
};
